module.exports = __webpack_public_path__ + "static/img/CX.80b59f1c.svg";